import { IApplicationState } from '../../../types/redux';

export const selectRegionsNew = (state: IApplicationState) => state.regionsNew;
